const defaultState = {
    isPlaying: false,
};

/* eslint-disable-next-line import/prefer-default-export */
export const getIsStimulusPlaying = (state = defaultState) => state.isPlaying;
